module.exports = __webpack_public_path__ + "media/assets/community_index/pattern-ba3ee3c560df467e3edb621136931c553dc914aa2a183de084260cf4eb8e1da9.png";